import { useDispatch, useSelector } from 'react-redux';

import { locales } from '@/config/locales';
import { useLocaleSettings } from '@/hooks/useLocaleSettings';
import { updateUser } from '@/redux/modules/auth/userProfile';
import { getIsAuthenticated } from '@/redux/selectors/auth/user';
import { isLocale } from '@/utility/i18n';
import { logger } from '@/utility/logger';

export const localeOptions = Object.values(locales).map(({ name, language, locale }) => ({
  label: `${name} (${language})`,
  value: locale,
  data: { name, language },
}));

export function useSessionLocale(): [string, (value: string) => Promise<void>] {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(getIsAuthenticated);
  const { locale: selectedLocale } = useLocaleSettings();

  const updateLocale = async (value: string) => {
    if (!isLocale(value)) return;

    try {
      if (isAuthenticated) {
        await dispatch(updateUser({ locale: { language: value } }));
      }

      if (process.env.NODE_ENV === 'production') {
        window.location.href =
          window.location.protocol +
          '//' +
          locales[value].domain +
          window.location.pathname +
          window.location.search;
      } else {
        window.location.reload();
      }
    } catch {
      logger.warn('Could not change locale.');
    }
  };

  return [selectedLocale, updateLocale];
}
